var render = function (_h,_vm) {var _c=_vm._c;return _c('v-dialog',{attrs:{"value":_vm.props.value,"max-width":_vm.props.maxWidth},on:{"input":_vm.listeners.input}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }